const helpIcon = `
	<svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Settings-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="DB-Settings--PS--overlay" transform="translate(-604.000000, -281.000000)">
            <g id="Group-11" transform="translate(309.000000, 280.000000)">
                <g id="help-circle" transform="translate(296.000000, 1.000000)">
                    <g id="Outline_Icons_1_" transform="translate(0.000000, 0.750000)" stroke="#C9CCCD" stroke-linejoin="round">
                        <g id="Outline_Icons">
                            <g id="Group">
                                <circle id="Oval" stroke-linecap="round" cx="8.625" cy="8.625" r="8.25"></circle>
                                <path d="M6.375,6.75 C6.375,5.508 7.38225,4.5 8.625,4.5 C9.867,4.5 10.875,5.508 10.875,6.75 C10.875,7.9935 9.867,9 8.625,9 L8.625,11.25" id="Path" stroke-linecap="round"></path>
                                <path d="M9,13.125 C9,13.332 8.832,13.5 8.625,13.5 L8.625,13.5 C8.418,13.5 8.25,13.332 8.25,13.125 L8.25,13.125 C8.25,12.918 8.418,12.75 8.625,12.75 L8.625,12.75 C8.832,12.75 9,12.918 9,13.125 L9,13.125 Z" id="Path"></path>
                            </g>
                        </g>
                    </g>
                    <g id="Invisible_Shape">
                        <polygon id="Rectangle" points="0 0 18 0 18 18 7.56292273 18 0 18"></polygon>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;

export default helpIcon;
